import React, { Component } from "react";
import { teamdata } from "../services/Teams";
import trophy from "../Statics/Trophy.png";
import fireworks from "../Statics/fireworks.png"

const Pointstable = () => {
  return (
    <>
      <table class="table">
        <thead class="thead-dark">
          <tr>
            <th scope="col">Rank</th>
            <th scope="col">TEAMS</th>
            <th scope="col">MATCHES PLAYED</th>
            <th scope="col">POINTS</th>
          </tr>
        </thead>
        <tbody>
          {teamdata.map((val) => (
            <tr>
              <th scope="row">{teamdata.indexOf(val) + 1}</th>
              <td>
                <b>{val.name}</b>
              </td>
              <td>
                <b>{val.matchesplayed}</b>
              </td>
              <td>
                <b>{val.points}</b>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      <nav class="navbar navbar-light bg-dark" style={{ margin: "10px" }}>
        <a
          class="navbar-brand text-white"
          style={{ paddingLeft: "500px" }}
          href="#"
        >
          <img
            src={trophy}
            width="30"
            height="30"
            class="d-inline-block align-top"
            alt=""
          />
          WINNER OF THE TOURNAMENT
          <img
            src={trophy}
            width="30"
            height="30"
            class="d-inline-block align-top"
            alt=""
          />
        </a>
      </nav>
      <div className="text-uppercase bg-dark text-light" style={{textAlign:"center", marginLeft:"350px", width:"50%", height:"50px",paddingTop:"11px"}}>
         <span>
             <img src={fireworks} width="30"
            height="30"
            class="d-inline-block align-top" alt="" />
         <b>TEAM INDIA</b>
         <img src={fireworks} width="30"
            height="30"
            class="d-inline-block align-top" alt="" />
             </span> 

      </div>
      <nav class="navbar navbar-light bg-dark " style={{ margin: "10px" }}>
        <a
          class="navbar-brand text-white"
          style={{ paddingLeft: "550px" }}
          href="#"
        >
          <img
            src={trophy}
            width="30"
            height="30"
            class="d-inline-block align-top"
            alt=""
          />
          FIRST RUNNER UP
          <img
            src={trophy}
            width="30"
            height="30"
            class="d-inline-block align-top"
            alt=""
          />
        </a>
      </nav>
      <div className="text-uppercase bg-dark text-light" style={{textAlign:"center", marginLeft:"350px", width:"50%", height:"50px",paddingTop:"11px"}}>
         <span style={{margin:"4px"}}>
             <img src={fireworks} width="30"
            height="30"
            class="d-inline-block align-top" alt="" />
         <b>TEAM AUSTRALIA</b>
         <img src={fireworks} width="30"
            height="30"
            class="d-inline-block align-top" alt="" />
             </span> 

      </div>
      
    </>
  );
};

export default Pointstable;
